<template>
  <session-rating-question-layout :title="title">
    <template>
      <div class="columns is-centered is-multiline mb-0 is-gapless">
        <template v-for="(item, index) in answers">
          <div class="column is-half" :key="index">
            <div class="checkbox-gap">
              <session-rating-checkbox :answer="item" :current-value="getCurrentValue(item)"
                                       @input="check(item, $event)"></session-rating-checkbox>
            </div>
          </div>
        </template>
      </div>
    </template>
  </session-rating-question-layout>
</template>

<script>
import SessionRatingQuestionLayout from "@/widgets/agenda/components/rating/SessionRatingQuestionLayout";
import SessionRatingCheckbox from "@/widgets/agenda/components/rating/SessionRatingCheckbox";

export default {
  name: "SessionRatingClosedQuestion",

  components: {SessionRatingQuestionLayout, SessionRatingCheckbox},

  props: {
    rating: {
      type: Object,
      required: true,
    },

    currentResponse: {
      type: Array,
    },
  },

  data() {
    return {
      responses: {},
    };
  },

  computed: {
    title() {
      return this.rating.title;
    },

    ratingId() {
      return this.rating.id;
    },

    answers() {
      return this.rating.agenda_session_rating_answers;
    },

    type() {
      return this.rating.rating_type;
    },
  },

  methods: {
    check(answer, isChecked) {
      this.responses[answer.id] = isChecked;
      this.emitUpdate();
    },

    emitUpdate() {
      const checkedResponses = Object.entries(this.responses)
        .filter(entry => entry[1])
        .map(entry => Number.parseInt(entry[0]));
      this.$emit("input", {ratingId: this.ratingId, type: this.type, responses: checkedResponses});
    },

    getCurrentValue(answer) {
      const response = this.responses[answer.id];
      if (response) {
        return response;
      } else {
        return false;
      }
    },
  },

  watch: {
    currentResponse: {
      immediate: true,
      handler: function (newValue) {
        if (newValue && newValue.length) {
          newValue.forEach(response => {
            this.responses[response] = true;
          });
          this.emitUpdate();
        }
      },
    }
  },
};
</script>

<style scoped>
.checkbox-gap {
  padding: 4px !important;
  height: 100%;
}
</style>
